// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tHb3JUvnkKXjkrvzRvkdkE
// Component: uqvQn8vklP
import * as React from "react"
import * as p from "@plasmicapp/react-web"
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
} from "@plasmicapp/react-web"
import NavBar from "../../NavBar" // plasmic-import: mLUHVmPRevK/component
import ResourcesTextBox from "../../ResourcesTextBox" // plasmic-import: PqHrVns2f7/component
import Footer from "../../Footer" // plasmic-import: 32zO-A5kqAr/component
import { useScreenVariants as useScreenVariants_7WQHcNbMsC8 } from "./PlasmicGlobalVariant__Screen" // plasmic-import: 7wQHcNbMsC8/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css"
import * as projectcss from "./plasmic_stack_input_site.module.css" // plasmic-import: tHb3JUvnkKXjkrvzRvkdkE/projectcss
import * as sty from "./PlasmicIdeas.module.css" // plasmic-import: uqvQn8vklP/css
import _1PngWKXgaEo11 from "./images/_1Png.png" // plasmic-import: wKXgaEo11/picture

export const PlasmicIdeas__VariantProps = new Array()

export const PlasmicIdeas__ArgProps = new Array()

function PlasmicIdeas__RenderFunc(props) {
  const { variants, args, overrides, forNode } = props
  const $props = props.args
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariants_7WQHcNbMsC8(),
  })

  return (
    <React.Fragment>
      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={projectcss.plasmic_page_wrapper}>
        <p.Stack
          as={"div"}
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          hasGap={true}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__fgCpm)}>
            <NavBar
              data-plasmic-name={"navBar"}
              data-plasmic-override={overrides.navBar}
              className={classNames("__wab_instance", sty.navBar)}
            />

            <div className={classNames(projectcss.all, sty.freeBox__iVu0H)}>
              <h1
                className={classNames(
                  projectcss.all,
                  projectcss.h1,
                  projectcss.__wab_text,
                  sty.h1__umCBc
                )}
              >
                {"101 Ideas to Get Started"}
              </h1>

              <div
                data-plasmic-name={"text"}
                data-plasmic-override={overrides.text}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text
                )}
              >
                <React.Fragment>
                  <React.Fragment>
                    {
                      "The internet is filled with entrepreneurial and vague, project-starting clickbait "
                    }
                  </React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ fontStyle: "italic" }}
                  >
                    {
                      '(*Ten great ideas to start your first project! A calculator... The game "Snake." And other *cough* garbage suggestions).'
                    }
                  </span>
                  <React.Fragment>
                    {
                      " We believe the best way to learn is by doing, so we write regularly on a product idea that could legitimately be scaled and how we'd approach building it from a programming, business and marketing standpoint."
                    }
                  </React.Fragment>
                </React.Fragment>
              </div>

              <h1
                className={classNames(
                  projectcss.all,
                  projectcss.h1,
                  projectcss.__wab_text,
                  sty.h1__k9QX9
                )}
              >
                {"101 Ideas"}
              </h1>

              <div className={classNames(projectcss.all, sty.freeBox__kEGx)}>
                <p.Stack
                  as={"div"}
                  data-plasmic-name={"postList"}
                  data-plasmic-override={overrides.postList}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.postList)}
                >
                  <div
                    className={classNames(projectcss.all, sty.column___67R2A)}
                  >
                    <ResourcesTextBox
                      data-plasmic-name={"resourcesTextBox"}
                      data-plasmic-override={overrides.resourcesTextBox}
                      className={classNames(
                        "__wab_instance",
                        sty.resourcesTextBox
                      )}
                      image={{
                        src: _1PngWKXgaEo11,
                        fullWidth: 512,
                        fullHeight: 511,
                        aspectRatio: undefined,
                      }}
                    />
                  </div>

                  <div
                    className={classNames(projectcss.all, sty.column__xwF6E)}
                  />

                  <div
                    className={classNames(projectcss.all, sty.column__qwHl6)}
                  />

                  <div
                    className={classNames(projectcss.all, sty.column__faL7T)}
                  />
                </p.Stack>
              </div>
            </div>
          </div>

          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer)}
          />
        </p.Stack>
      </div>
    </React.Fragment>
  )
}

const PlasmicDescendants = {
  root: ["root", "navBar", "text", "postList", "resourcesTextBox", "footer"],
  navBar: ["navBar"],
  text: ["text"],
  postList: ["postList", "resourcesTextBox"],
  resourcesTextBox: ["resourcesTextBox"],
  footer: ["footer"],
}

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = deriveRenderOpts(props, {
      name: nodeName,
      descendantNames: [...PlasmicDescendants[nodeName]],
      internalArgPropNames: PlasmicIdeas__ArgProps,
      internalVariantPropNames: PlasmicIdeas__VariantProps,
    })

    return PlasmicIdeas__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    })
  }
  if (nodeName === "root") {
    func.displayName = "PlasmicIdeas"
  } else {
    func.displayName = `PlasmicIdeas.${nodeName}`
  }
  return func
}

export const PlasmicIdeas = Object.assign(
  // Top-level PlasmicIdeas renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    navBar: makeNodeComponent("navBar"),
    text: makeNodeComponent("text"),
    postList: makeNodeComponent("postList"),
    resourcesTextBox: makeNodeComponent("resourcesTextBox"),
    footer: makeNodeComponent("footer"),
    // Metadata about props expected for PlasmicIdeas
    internalVariantProps: PlasmicIdeas__VariantProps,
    internalArgProps: PlasmicIdeas__ArgProps,
  }
)

export default PlasmicIdeas
/* prettier-ignore-end */
